import {UI} from "../../stem-core/ui/UIBase";
import {UserChargesList} from "../components/users/payments/UserChargesList.jsx";

export class AdminChargesPage extends UI.Element {
    render() {
        return <UserChargesList />;
    }
}
